const loadScript = (source, id, callback) =>
  new Promise((resolve, reject) => {
    const script = document.createElement("script");
    if (id) {
      script.id = id;
    }
    script.async = true;
    script.src = source;
    script.type = "text/javascript";
    script.onload = script.onreadystatechange = function() {
      if (callback) {
        callback(this);
      }
      resolve();
    };
    script.onerror = (event) =>
      reject(`${event.target.src} failed to load. ¯\\_(ツ)_/¯`);
    document.body.appendChild(script);
  });

export default loadScript;
